import { FIRSTPASSWORD_URL, LOGIN_URL } from '../config/config'

import { CognitoJwtVerifier } from "aws-jwt-verify";
import { APPCLIENT_ID, USERPOOL_ID } from '../config/env'

// Verifier that expects valid access tokens:
const verifier = CognitoJwtVerifier.create({
  userPoolId: USERPOOL_ID,
  tokenUse: "id",
  clientId: APPCLIENT_ID,
});

export const isLogin = () =>{
  const user = getUser();
  const idtoken = getIdToken();

  if(user && idtoken){
    if(user.exp){
      const now = Date.now();
      if(user.exp * 1000 > now){
        return true;
      }
    }

  }

  return false;
}

export const getUser = () => {
  const user = JSON.parse(sessionStorage.getItem("user.idtoken.decode"));

  if(user){
    return {
      id: user['cognito:username'],
      email: user.email,
      exp: user.exp,
    }
  }else{
    return null;
  }

}

export const decodeUser = async () =>{
  const token = getIdToken();
  try {
    const decode = await verifier.verify(token);
    sessionStorage.setItem("user.idtoken.decode",JSON.stringify(decode));
  }catch(err){
    console.log("Error",err);
  }
};


export const loginPassword = async (args) =>{
  const loginParam = {
    "authFlow": "USER_PASSWORD_AUTH",
    "username": args.email,
    "password": args.password
  };

  return await loginProcess(loginParam)
}

export const loginRefreshToken = async () => {
  const refreshToken = sessionStorage.getItem("user.token.refresh");

  if(!refreshToken){
    console.log("loginRefreshToken","リフレッシュトークンがありません")
    const refreshTokenNone = {
      message: "リフレッシュトークンがありません",
      needLogin: true,
      isError: true,
    }

    return refreshTokenNone;
  }

  const loginParam = {
    "authFlow": "REFRESH_TOKEN_AUTH",
    "refreshToken": refreshToken,
  };

  return await loginProcess(loginParam)
};

async function loginProcess(loginParam) {
  const body = JSON.stringify(loginParam)

  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
  let result = {}
  try {
    const res = await fetch(LOGIN_URL, { method: 'POST', headers, body })
    result.isError = false
    let json = await res.json()

    if (res.ok) { // HTTP ステータスが 200-299 の場合
      // レスポンスの本文を取得(後述)
      result.json = json
    } else {
      console.log(json)
      result.isError = true
    }

  } catch (err) {
    result = {
      isError: true,
      message: err.message,
    }

  }
  return result
}


export const getIdToken = () => {
  return sessionStorage.getItem("user.token.id");
}

export const getAccessToken = () => {
  return sessionStorage.getItem("user.token.access");
}

export const setUser = (credential) => {
  sessionStorage.setItem("user.token.id",credential.idToken);
  sessionStorage.setItem("user.token.access",credential.accessToken);
  if(credential.refreshToken){
    sessionStorage.setItem("user.token.refresh",credential.refreshToken);
  }

}

export const setPasswordForFirstLogin = async (password,session,username) =>{

  console.log(password);
  const url = FIRSTPASSWORD_URL;
  const parameter = {
    "password": password,
    "session": session,
    "username": username
  }

  const body = JSON.stringify(parameter)
  console.log("First Login",body)
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }

  try {
    const res = await fetch(url, { method: 'POST', headers, body });
    if (res.ok) {
      return res;
    }

  }catch(err){
    console.log(err);
    return;
  }

  return ;

}


export const logOut = ()=>{
  sessionStorage.clear();

}